// TD1-10685: option-group dropdowns on the item / add-on detail page.

// AvailableItem's productType (route factory argument) → the API's option group item type.
const STOREFRONT_ITEM_TYPES = {
  items: 'Product',
  add_ons: 'AddOn',
};

const DETAIL_PATH_SEGMENTS = {
  Product: 'items',
  AddOn: 'addons',
};

export const optionGroupItemType = (productType) =>
  STOREFRONT_ITEM_TYPES[productType] || null;

// A group may mix items and add-ons, so an option can live under either detail route.
export const optionDetailPath = ({ itemType, token, slug }) => {
  const segment = DETAIL_PATH_SEGMENTS[itemType];
  if (!segment || !token) return null;

  return slug
    ? `/shop/${segment}/${token}/${slug}`
    : `/shop/${segment}/${token}`;
};

// History state a dropdown pick pushes, so the page it opens knows it is switching options.
export const OPTION_SWITCH_STATE = { optionSwitch: true };

// The detail page shows its loading state while the product it fetches is not the one in the store yet. A pick
// that crosses between items and add-ons finds the other page type's store slot empty (no token), so the history
// state marks it too; a first direct page load has neither and renders as before.
export const isSwitchingProduct = ({
  loading,
  storedToken,
  routeToken,
  locationState,
}) =>
  Boolean(loading) &&
  storedToken !== routeToken &&
  (Boolean(storedToken) ||
    Boolean(locationState && locationState.optionSwitch));

export const currentOptionToken = (options) =>
  (options.find((option) => option.current) || {}).token || '';
